import { toast } from "react-toastify";

import { LOAD_COLLECTIONS_ROUTINE } from "@/constants/ActionTypes";
import { getUserFriendlyErrorMessage } from "api/UserFriendlyError";
import { getCollections } from "api/media-library";
import { isFullLibrary, UserWithPlan } from "features/media-library";
import { getCollections as selectCollections } from "selectors/mediaLibrarySelectors";
import {
  getCollectionsError,
  getIsLoadingCollections,
} from "selectors/mediaLibrarySelectors";
import { ReduxRootState } from "@/types/redux-store";
import { isEditorUploadsCollection } from "utils/cesdk-editor-collection";

export async function fetchVisibleCollections(user?: UserWithPlan) {
  const collections = await getCollections();
  // Filter out Editor Uploads collection (managed by ceSDK editor)
  const visibleCollections = collections.filter(
    (c) => !isEditorUploadsCollection(c)
  );

  return isFullLibrary(user)
    ? visibleCollections
    : visibleCollections.filter((c) => c.isSystemInbox);
}

export const loadMediaCollections =
  (user?: UserWithPlan) =>
  async (
    dispatch: (action: {
      type: string;
      payload?: unknown;
      error?: boolean;
    }) => void,
    getState: () => ReduxRootState
  ) => {
    const currentUser = (user ?? getState()?.user) as UserWithPlan | undefined;

    dispatch({ type: LOAD_COLLECTIONS_ROUTINE.REQUEST });

    try {
      const collections = await fetchVisibleCollections(currentUser);

      dispatch({
        type: LOAD_COLLECTIONS_ROUTINE.SUCCESS,
        payload: {
          collections,
        },
      });

      return collections;
    } catch (error) {
      dispatch({
        type: LOAD_COLLECTIONS_ROUTINE.FAILURE,
        error: true,
        payload: error,
      });

      toast.error(getUserFriendlyErrorMessage(error as Error));

      throw error;
    }
  };

export const selectVisibleMediaCollections = (state: ReduxRootState) =>
  selectCollections(state);

export const selectMediaCollectionsView = (state: ReduxRootState) => ({
  collections: selectVisibleMediaCollections(state),
  loadingError: getCollectionsError(state),
  isLoading: getIsLoadingCollections(state),
});
